export enum UserRole {
  ACTOR = 'Actor',
  DIRECTOR = 'CastingDirector',
}
